export default (function (siteVars) {
  return {
    boxShadow: 'none',
    rootBackground: siteVars.colors.black,
    foregroundColor: siteVars.colors.white
  };
});